module.exports = __webpack_public_path__ + "img/fantastic.9aeeb3ba.svg";